
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2023
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'prueba',
	'visualizationSlideoutTitle': 'Visualizaciones',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Escriba un número',
	'maxValuePlaceholder': 'Escriba un número',
	'customRangeErrorMessage': 'El valor debe ser un número',
	'propFillColor': 'Color de relleno',
	'propBorderColor': 'Color del borde',
	'propBorderRadius': 'Radio de esquina (px)',
	'propColorPalette': 'Paleta de colores actual',
	'propColorPaletteChangeLabel': 'Cambiar paleta de colores',
	'propNewColorPaletteLabel': 'Crear una paleta de colores personalizada',
	'propNewHeatPaletteLabel': 'Crear una paleta de uso crítico personalizada',
	'showTitleLabel': 'Mostrar título',
	'titleTypeLabel': 'Tipo de título',
	'smartTitleLabel': 'Título inteligente',
	'customTitleLabel': 'Título personalizado',
	'noTitleLabel': 'Sin título',
	'colorPaletteTitle': 'palette',
	'responsiveTitleLabel': 'Título receptivo',
	'propHeatScalePalette': 'Paleta de uso crítico actual',
	'propHeatPaletteChangeLabel': 'Cambiar paleta de uso crítico',
	'propMaintainAxisScales': 'Mantener escala de eje',
	'propLineAndSymbolColor': 'Color de línea y símbolo',
	'propLineAndSymbolPalette': 'Paleta de colores de líneas y símbolos',
	'propElementColor': 'Color de elementos',
	'propColumnColor': 'Color de columnas',
	'propColumnPalette': 'Paleta de colores de columna',
	'propColumnHeatPalette': 'Paleta de uso crítico de columnas',
	'propBarColor': 'Color de barra',
	'propGoalColor': 'Color de destino',
	'propToColor': 'A color',
	'propFromColor': 'De color',
	'propNumberValidationErrorMessageId': 'Escriba un número',
	'fontSizeAuto': 'Automático',
	'propAutoBinCount': 'Número de grupos',
	'propAutoBinToggle': 'Agrupación automática',
	'tabName_general': 'General',
	'tabName_visDetails': 'Detalles',
	'tabName_animation': 'Animación',
	'tabName_mediaDetails': 'Detalles del soporte multimedia',
	'tabName_webDetails': 'Detalles de la página web',
	'tabName_imageDetails': 'Detalles de la imagen',
	'tabName_visualization': 'Visualización',
	'tabName_text': 'Texto',
	'sectionName_colorsAndThemes': 'Color y temas',
	'sectionName_appearance': 'Aspecto',
	'sectionName_general': 'General',
	'sectionName_colorPalette': 'Color',
	'sectionName_axis': 'Eje',
	'sectionName_axis_label': 'Eje',
	'sectionName_legend': 'Leyenda',
	'sectionName_chart': 'Gráfico',
	'sectionName_regionLayer': 'Capa de regiones',
	'sectionName_pointLayer': 'Capa de puntos',
	'sectionName_latLongLayer': 'Capa de latitud/longitud',
	'sectionName_pathLayer': 'Capa de vía de acceso',
	'sectionName_xAxis': 'Eje X',
	'sectionName_yAxis': 'Eje Y',
	'sectionName_xAxis_title': 'Título de eje X',
	'sectionName_yAxis_title': 'Título de eje Y',
	'sectionName_xAxis_label': 'Etiqueta de eje X',
	'sectionName_yAxis_label': 'Etiqueta de eje Y',
	'sectionName_column_yAxis': 'Eje Y de columna',
	'sectionName_column_yAxis_label': 'Etiqueta de eje Y de columna',
	'sectionName_column_yAxis_title': 'Título de eje Y de columna',
	'sectionName_line_yAxis': 'Eje Y de línea',
	'sectionName_line_yAxis_label': 'Etiqueta de eje Y de línea',
	'sectionName_line_yAxis_title': 'Título de eje Y de línea',
	'sectionName_title': 'Título',
	'sectionName_legendTitle': 'Título de leyenda',
	'sectionName_legendLabels': 'Etiquetas de leyenda',
	'sectionName_innerValueLabel': 'Etiqueta de valor interna',
	'sectionName_style': 'Estilo',
	'propTransparencyDescription': 'Hacer que el objeto sea más o menos transparente. Especifique un valor entre 0 y 100',
	'smart_annotation_unauthorized': 'Anotaciones: acceso no autorizado',
	'smart_annotation_method': 'Anotaciones: método no permitido',
	'smart_annotation_media': 'Anotaciones: tipo de soporte no permitido',
	'smart_annotation_input': 'Anotaciones: entrada no válida',
	'smart_annotation_internal': 'Anotaciones: error interno del sistema',
	'smart_annotation_generic_error': 'Anotaciones: error de servicio',
	'smart_annotation_dialog_title': 'Conocimientos',
	'smart_annotation_Show_Insights': 'Mostrar conocimientos',
	'smart_annotation_Relationship': 'La relación es',
	'forecast_enter_number': 'Escriba un número entre ',
	'and': ' y ',
	'smart_errors': 'Errores de anotación:',
	'smart_warnings': 'Avisos de anotación:',
	'smart_annotation_insight_icon_title': 'Conocimientos',
	'smart_annotations_toggle_on': 'Activar conocimientos',
	'smart_annotations_toggle_off': 'Desactivar conocimientos',
	'smart_annotation_toggle_on': 'Conmutar activado ',
	'smart_annotation_toggle_off': 'Conmutar desactivado',
	'smart_annotation_insight_unavailable': 'Los conocimientos no están disponibles actualmente',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Los conocimientos no están disponibles cuando se aplica el filtro de % superior o inferior',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Las predicciones no están disponibles cuando se aplica el filtro de % superior o inferior',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Los conocimientos no están disponibles cuando se aplica el filtro de porcentaje superior o inferior y hay más de una columna en el campo',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'Las predicciones no están disponibles cuando se aplica el filtro de porcentaje superior o inferior y hay más de una columna en el campo',
	'forecast_title': 'Predicción',
	'forecast_show': 'Mostrar previsión',
	'forecast_toggle_on': 'Conmutar activar predicción',
	'forecast_toggle_off': 'Conmutar desactivar predicción',
	'statDetails_title': 'Ver detalles estadísticos',
	'forecast_optional_factors_max_info': 'Se puede añadir un máximo de %{max} factores',
	'forecast_optional_factors_num_added': '%{added}/%{max}',
	'forecast_optional_factors': 'Factores opcionales a considerar',
	'forecast_optional_factors_placeholderDropzone': 'Pulse o arrastre los datos aquí',
	'forecast_item_tooltip': 'Origen:',
	'insightsNarrator': 'Información narrativa',
	'statDetailsPerspectiveTitle': 'Análisis',
	'emptyStatDetailsPanel': 'No hay ningún análisis adicional disponible para la visualización actual.',
	'predict_errors': 'Errores de análisis',
	'predict_warnings': 'Avisos de análisis',
	'fpd_invalid_data_source': 'Este origen de datos no tiene asociado un módulo Smarts',
	'fpd_network_issue': 'Se ha producido un problema al realizar un análisis en este origen de datos',
	'fpd_data_source_category': 'Falta un módulo Smarts',
	'fpd_response_errors': 'Errores de controladores recomendados',
	'fpd_response_warnings': 'Avisos de controladores recomendados',
	'catalyst_service_bad_request': 'Solicitud incorrecta',
	'catalyst_service_unkown_Id': 'Se ha encontrado una ID de solicitud desconocida',
	'catalyst_service_internal_server_error': 'Error interno del servidor',
	'catalyst_service_generic_error': 'Error de servicio Catalyst',
	'catalyst_service_error': 'Este servicio no está disponible actualmente.',
	'propLegendPosition': 'Posición de la leyenda',
	'propLeft': 'Izquierda',
	'propRight': 'Derecha',
	'propTop': 'Superior',
	'propBottom': 'Abajo',
	'propNone': 'Ninguno',
	'propLegendDisplay': 'Visualizar leyenda',
	'targetThicknessPlaceHolder': '%{min} hasta %{max}',
	'targetThicknessErrorMsg': 'Especifique un número entero entre %{min} y %{max}.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Controladores (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'seleccionado)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Restablecer los valores predeterminados',
	'possibelKeyDriver_AddNewDrivers': 'Añadir más controladores',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Buscar para añadir más controladores',
	'possibleKeyDrivers_MaxPossibleReached': 'Deseleccione algunos controladores para añadir o seleccionar otros',
	'possibleKeyDrivers_Recommended': 'Recomendado',
	'visRecommendedTypes': 'Tipos de visualización recomendados',
	'visRecommender_smartsfailure': 'las recomendaciones de visualización no están disponibles actualmente',
	'visMore': 'Más...',
	'visMoreTooltip': 'Más visualizaciones',
	'visOtherTypes': 'Otros tipos de visualización',
	'visChange': 'Cambiar visualización',
	'automaticTypeCaption': 'Automático',
	'propVisType': 'Tipos de visualización',
	'dlg_loading': 'Cargando...',
	'snippetListChartCaption': 'Lista de fragmentos',
	'convoClusterChartCaption': 'Clúster de conversaciones',
	'areaChartCaption': 'Área',
	'barChartCaption': 'Barra',
	'columnChartCaption': 'Columna',
	'stackedbarChartCaption': 'Barras apiladas',
	'stackedcolumnChartCaption': 'Columnas apiladas',
	'bubbleChartCaption': 'Burbuja',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Análisis de controlador',
	'scatterChartCaption': 'Dispersión',
	'lineChartCaption': 'Línea',
	'pointChartCaption': 'Puntos',
	'heatChartCaption': 'Mapa de uso crítico',
	'bulletChartCaption': 'Viñeta',
	'waterfallChartCaption': 'Cascada',
	'radarChartCaption': 'Radar',
	'boxplotChartCaption': 'Diagrama de caja',
	'pieChartCaption': 'Circular',
	'mapChartCaption': 'Mapa',
	'radialBarChartCaption': 'Radial',
	'compositeChartCaption': 'Línea y columna',
	'wordCloudChartCaption': 'Nube de palabras',
	'networkChartCaption': 'Red',
	'relationshipNetworkChartCaption': 'Red de relaciones',
	'treemapChartCaption': 'Mapa de árbol',
	'packedBubbleChartCaption': 'Burbuja empaquetada',
	'hierarcicalPackedBubbleChartCaption': 'Burbuja de jerarquía',
	'spiralChartCaption': 'Espiral',
	'decisionTreeChartCaption': 'Árbol de decisiones',
	'legacyMapChartCaption': 'Mapa heredado',
	'sunburstChartCaption': 'Sunburst',
	'visUsageComparison': 'Comparación',
	'visUsageRelationships': 'Relaciones',
	'visUsageTrend': 'Tendencia',
	'visUsagePartsToWhole': 'Componentes del conjunto',
	'visUsageGeospatial': 'Geoespacial',
	'visUsageAdvanced': 'Análisis avanzado',
	'visUsageTablesAndSummary': 'Tablas y resumen',
	'visUsageSocialInsights': 'Social Insights',
	'visUsageOther': 'Otros',
	'visualizationAnalytics': 'Análisis',
	'autoBinActionText': 'Agrupar automáticamente',
	'filterAutobinActionText': 'Filtrar cubetas',
	'memberCalculationActionText': 'Cálculo de miembros',
	'toolbarActionCalculation': 'Crear cálculo',
	'toolbarActionEditCalculation': 'Editar cálculo',
	'topBottomRankLabel': 'Rango (%{label})',
	'toolbarDeleteFilterActionText': 'Eliminar filtro',
	'toolbarActionTopKeyDrivers': 'Mostrar controladores',
	'toolbarActionCustomGroup': 'Grupo personalizado',
	'canNotCreateCustomGroup': 'No se puede crear este grupo personalizado.',
	'aria_label_datatable': 'Tabla de datos',
	'summaryCaption': 'Resumen',
	'MeasuresCaption': 'Medidas',
	'MeasuresGroupCaption': 'Grupo de medidas (%{count})',
	'ValuesCaption': 'Valores',
	'turnInsightsOn': 'Activar conocimientos',
	'turnInsightsOff': 'Desactivar conocimientos',
	'decisionRules': 'Reglas',
	'decisionTree': 'Diagrama de árbol',
	'decisionSunburst': 'Árbol Sunburst',
	'switchToDecisionRules': 'Cambiar a las reglas de decisión',
	'switchToDecisionTree': 'Cambiar al árbol de decisión',
	'data_group_less_then': 'menor que %{rangeTo}',
	'data_group_to': '%{rangeFrom} hasta < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} y superior',
	'nullValueContent': '(ningún valor)',
	'sum': 'Suma',
	'count': 'Recuento',
	'countdistinct': 'Recuento distincto',
	'avg': 'Promedio',
	'min': 'Mínimo',
	'max': 'Máximo',
	'automatic': 'Personalizado',
	'variance': 'Varianza',
	'stddev': 'Desviación estándar',
	'median': 'Mediana',
	'calculated': 'Calculado',
	'none': 'Ninguno',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': 'Valores de solicitud',
	'inputLabelPrompt': 'Valor',
	'inputPlaceholderPrompt': 'Especificar valor',
	'inputInvalidText': 'Entrada no válida para el tipo %{dataType}',
	'unSupportedPrompt': 'Solicitud no soportada',
	'missingDataSource': 'No se ha podido encontrar el origen de datos correcto.',
	'unSupportedPromptType': 'El escenario de solicitud no está soportado actualmente.',
	'preAggregateLabel': 'Aplicar valores de solicitud del origen de datos',
	'postAggregateLabel': 'Aplicar valores de solicitud en el informe',
	'preAggregateText': 'El rango utiliza los valores del origen de datos, no los valores mostrados en el panel de control.',
	'defaultAggregation_count': 'Recuento',
	'defaultAggregation_countdistinct': 'Recuento distincto',
	'defaultAggregation_max': 'Máximo',
	'defaultAggregation_min': 'Mínimo',
	'defaultAggregation_avg': 'Promedio',
	'defaultAggregation_sum': 'Suma',
	'defaultAggregation_auto': 'Automático (%{aggregationType})',
	'keydriver_average': 'Promedio general',
	'keydriver_up_down': 'Los grupos resaltados con promedios altos o bajos tienen más impacto en el destino. Los grupos con promedios más altos o bajos de lo habitual tienen el impacto más fuerte.',
	'keydriver_different': 'Los grupos resaltados tienen distribuciones que difieren de forma destacada de la distribución global. Estos grupos tienen más impacto en el destino.',
	'topOperator': 'Superior',
	'bottomOperator': 'Abajo',
	'topBottomFact': '%{operator} %{value}%{percent} por %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Suprimir recuento superior o inferior',
	'deleteTopBottomPercent': 'Suprimir % superior o inferior',
	'topBottomTitle': 'Este objeto solamente',
	'deleteTopBottom': 'Suprimir recuento superior o inferior',
	'editTopBottom': 'Editar recuento superior o inferior',
	'editTopBottomCount': 'Editar recuento superior o inferior',
	'editTopBottomPercent': 'Editar % superior o inferior',
	'deleteDrillOperation': 'Cancelar operación de profundización',
	'ariaDeleteTopBottomCountLabel': 'Pulse la tecla DELETE (suprimir) para suprimir el recuento superior o inferior.',
	'ariaDeleteTopBottomPercentLabel': 'Pulse la tecla Supr para suprimir el % superior o inferior.',
	'ariaEditTopBottomCountLabel': 'Pulse la tecla Intro para editar el recuento superior o inferior.',
	'ariaEditTopBottomPercentLabel': 'Pulse Intro para editar el % superior o inferior.',
	'ariaDeleteDrillStateLabel': 'Pulse la tecla INTRO para editar la operación de profundización.',
	'drillUpStateTitle': 'Detallar menos',
	'drillDownStateTitle': 'Detallar más',
	'ariaEditTopBottomLabel': 'Pulse la tecla Intro para editar el recuento superior o inferior.',
	'ariaDeleteTopBottomLabel': 'Pulse la tecla DELETE (suprimir) para suprimir el recuento superior o inferior.',
	'allKeyDriversLabel': 'Automático (todos los controladores)',
	'filter_drag_and_drop_single_dock': 'Arrastre y suelte los datos aquí para filtrar.',
	'filter_drag_and_drop_all_tabs': 'Arrastre y suelte los datos aquí para filtrar todas las pestañas.',
	'filter_drag_and_drop_current_tab': 'Arrastre y suelte los datos aquí para filtrar esta pestaña.',
	'filter_empty_consume_mode': 'No se ha aplicado ningún filtro.',
	'filterClearAllItems': 'Borrar todos los filtros',
	'filterDeleteAllItems': 'Suprimir todos los filtros',
	'filterDockChevronLeft': 'Desplácese por los datos',
	'filterDockChevronRight': 'Desplácese por los datos',
	'filterIconLabel_Single': 'Filtros',
	'filterIconLabel_Global': 'Todas las pestañas',
	'filterIconLabel_Tab': 'Esta pestaña',
	'filterIconTooltip_Single': 'Filtros',
	'filterIconTooltip_Global': 'Filtros para todas las pestañas',
	'filterIconTooltip_Tab': 'Filtros para esta pestaña',
	'filterDropZoneTooltip_Single': 'Filtrar zona de colocación',
	'filterDropZoneTooltip_Global': 'Filtrar zona de colocación para todas las pestañas',
	'filterDropZoneTooltip_Tab': 'Filtrar zona de colocación para esta pestaña',
	'filterOverflowMenu': 'Más',
	'expand': 'Expandir',
	'collapse': 'Contraer',
	'filterDockItemNameAriaLabel': 'Pulse Intro para abrir el diálogo de filtro y definir el filtro.',
	'filterItemCanvasMove': 'Añadir al lienzo',
	'addToCascadeSet': 'Añadir al conjunto en cascada',
	'removeFromCascadeSet': 'Eliminar del conjunto en cascada',
	'filterItemDelete': 'Suprimir filtro',
	'filterInvertRange': 'todo excepto: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'No después de %{from}',
	'filter_date_after': 'Después de %{from}',
	'filter_date_before_except': 'No antes de %{to}',
	'filter_date_before': 'Antes de %{to}',
	'filter_date_between_except': 'No entre %{from}-%{to}',
	'filter_date_between': 'Entre %{from}-%{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Todo',
	'filter': 'Filtro',
	'filterExcept': 'excepto %{values}',
	'filterDockToolbarButtonLabel': 'Acoplador de filtro',
	'navigateTitle': 'Navegar a',
	'navigateSelectColumn': 'Seleccionar una columna',
	'navigateSelectPath': 'Seleccionar una ruta de navegación',
	'current_nav_group': 'El grupo de navegación actual es %{navigation_group_name}',
	'next': 'Siguiente',
	'previous': 'Anterior',
	'multiselectMsg': '%{count} seleccionado',
	'errMsgFilterItemMissingTitle': 'No se pueden cargar los valores de filtro %{itemName} debido a que estos valores no están disponibles con este conjunto de datos',
	'errMsgFilterItemGenericTitle': 'Los valores de filtro no pueden cargarse',
	'textFilterItemsNotFound': 'No hay ningún elemento disponible.',
	'nullValueLabel': '(en blanco)',
	'filterConditionLabel': 'Filtrar condición',
	'filter_includesAll': 'Incluye todo',
	'filter_allMembersOfSet': 'Todos los miembros del conjunto',
	'modelFilter': 'Filtro',
	'filtersTitle': 'Propiedades del filtro',
	'search': 'Buscar',
	'clearTextFilterValue': 'Borrar',
	'invertFilterSelection': 'Invertir',
	'modellingLoading': 'Cargando...',
	'searchAll': 'Buscar todas las columnas',
	'toolbarActionPossibleKeyDrivers': 'Editar ámbito',
	'toolbarActionPossibleKeyDriversSubTitle': 'Arrastre los elementos de la izquierda para que se tengan en cuenta en el gráfico de análisis de controladores',
	'toolbarActionSort': 'Ordenar',
	'toolbarActionSortAscending': 'Ascendente',
	'toolbarActionSortDescending': 'Descendente',
	'toolbarActionSortAuto': 'Automático (%{sortOrder})',
	'toolbarActionSortCustom': 'Personalizado',
	'toolbarActionFormat': 'Formatear datos',
	'toolbarActionFormatText': 'Formato de datos (texto)',
	'toolbarActionFormatAbbreviation': 'Abreviar',
	'toolbarActionFormatNone': 'Automático',
	'toolbarActionFilter': 'Filtro',
	'toolbarActionTopBottom': 'Parte superior o inferior',
	'toolbarActionRmvShape': 'Eliminar forma',
	'toolbarActionToggleShapeDrop': 'Forma infográfica',
	'toolbarActionToggleShapeDropTitle': 'Crear un infográfico',
	'toolbarActionToggleShapeDropText': 'Arrastre una forma a este campo para crear un infográfico.',
	'toolbarActionAggregationType': 'Resumir',
	'toolbarDeleteActionText': 'Eliminar columna',
	'toolbarTextActionText': 'Texto de estilo',
	'toolbarActionFilterLocalKeepSelected': 'Mantener',
	'toolbarActionFilterLocalExcludeSelected': 'Excluir',
	'toolbarActionFilterAllKeepSelected': 'Filtro',
	'toolbarActionSimpleCalculation': 'Cálculo simple',
	'toolbarActionDrillBack': 'Atrás',
	'toolbarActionDrillUp': 'Detallar menos',
	'toolbarActionDrillDown': 'Detallar más',
	'toolbarActionJumpTo': 'Acceso a detalles',
	'toolbarActionNavigate': 'Navegar',
	'toolbarActionCreateFilterGroup': 'Crear nueva conexión',
	'toolbarActionDisconnectFilterGroup': 'Romper todos los enlaces',
	'toolbarActionLinkFilterGroup': 'Añadir a una conexión existente',
	'toolbarActionLassoSelect': 'Seleccionar herramienta',
	'toolbarActionRefreshDeveloperWidget': 'Renovar',
	'textFontFamilySubClassHairline': 'Fina',
	'textFontFamilySubClassThin': 'Delgada',
	'textFontFamilySubClassThinItalic': 'Cursiva delgada',
	'textFontFamilySubClassExtraLight': 'Extra clara',
	'textFontFamilySubClassExtraLightItalic': 'Extra clara cursiva',
	'textFontFamilySubClassLight': 'Claro',
	'textFontFamilySubClassLightItalic': 'Cursiva clara',
	'textFontFamilySubClassRegular': 'Regular',
	'textFontFamilySubClassRegularItalic': 'Cursiva regular',
	'textFontFamilySubClassItalic': 'Cursiva',
	'textFontFamilySubClassMedium': 'Medio',
	'textFontFamilySubClassMediumItalic': 'Cursiva mediana',
	'textFontFamilySubClassHeavy': 'Intensa',
	'textFontFamilySubClassHeavyItalic': 'Cursiva intensa',
	'textFontFamilySubClassDemiBold': 'Semi-negrita',
	'textFontFamilySubClassDemiBoldItalic': 'Semi-negrita cursiva',
	'textFontFamilySubClassBold': 'Negrita',
	'textFontFamilySubClassBoldItalic': 'Negrita cursiva',
	'textFontFamilySubClassExtraBold': 'Extra negrita',
	'textFontFamilySubClassExtraBoldItalic': 'Extra negrita cursiva',
	'textFontFamilySubClassBlack': 'Negro',
	'textFontFamilySubClassBlackItalic': 'Negra cursiva',
	'textFontFamilySubClassStencil': 'Esténcil',
	'dlg_ascending': 'ascendente',
	'dlg_descending': 'descendente',
	'dlg_custom': 'personalizado',
	'dlg_none': 'ninguno',
	'dlg_hierarchy': 'jerarquía',
	'dlg_namedSet': 'conjunto con nombre',
	'dlg_rank': 'rango',
	'visualizationLabel': 'Visualización',
	'chartLabel': 'Diagrama %{chartName}',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Pulse F12 para navegar por el widget',
	'f10KeyDescription': 'Pulse F10 para lanzar la vista de enfoque de widget',
	'playButtonLabel': 'Reproducir',
	'dataPlayerValueListLabel': 'Valores del reproductor de datos',
	'localFilterTitle': 'Este objeto solamente',
	'globalFilterTitle': 'Todos los objetos',
	'deleteFilter': 'Suprimir filtro',
	'editFilter': 'Editar filtro',
	'ariaEditFilterLabel': 'Pulse la tecla INTRO para editar el filtro.',
	'ariaDeleteFilterLabel': 'Pulse la tecla SUPR para suprimir el filtro.',
	'measureFilterBetween': 'Entre %{lowerBound} y %{upperBound}',
	'measureFilterNotBetween': 'No entre %{lowerBound} y %{upperBound}',
	'dimFilterIn': 'Incluye: %{in}',
	'dimFilterNotIn': 'Excluye: %{out}',
	'gtFilter': 'Mayor que %{lowerBound}',
	'afterFilter': 'Después de %{lowerBound}',
	'beforeFilter': 'Antes de %{upperBound}',
	'gteFilter': 'Mayor o igual que %{lowerBound}',
	'ltFilter': 'Menor que %{upperBound}',
	'lteFilter': 'Menor o igual que %{upperBound}',
	'ariaEditPrompt': 'Pulse la tecla INTRO para cambiar el valor de solicitud',
	'dataPointFilterTitle': 'Puntos de datos',
	'dataPointFilterIncludeSummary': 'Incluidos %{valueCount} puntos de datos',
	'dataPointFilterExcludeSummary': 'Excluidos %{valueCount} puntos de datos',
	'widgetFiltersLabel': 'Filtros de widget',
	'coachMarkTitleSpiralTarget': 'Editar ámbito',
	'coachMarkContentSpiralTarget': 'Aquí puede acceder y modificar la selección de controlador de su destino.',
	'srILVTreeLabel': 'Lista',
	'geomapUnrecognizedLocations': 'Ubicaciones no reconocidas:',
	'geomapAmbiguousLocations': 'Regiones ambiguas:',
	'visualizationNotifications': 'Notificaciones de visualización:',
	'dataNotifications': 'Notificaciones de datos:',
	'autobinSuggestion': 'Activar agrupación automática',
	'LIVE_empty_visualization_hint_title': 'Crear su visualización',
	'LIVE_empty_visualization_hint_description': 'Arrastre y suelte aquí o en los campos.',
	'LIVE_slots_required_field_description': '%{asterisk} Indica un campo necesario',
	'LIVE_slots_drag_and_drop_description': 'Arrastre y suelte los datos en los campos para crear y filtrar la visualización.',
	'tooltipSlotDefaultCaption': 'Ayuda contextual',
	'tooltipSlotCompositeLineCaption': 'Ayuda contextual sobre la línea',
	'tooltipSlotCompositeColumnCaption': 'Ayuda contextual sobre la columna',
	'dwErrorLoadingAvailableVisualizations': 'No podemos cargar las definiciones de visualizaciones disponibles',
	'moreDataIndicator': 'Sus datos se han recortado en %{threshold} elementos. Aplique el filtro para mostrar menos.',
	'nonCtxTopBottomInvalid': 'La definición de una regla superior o inferior sin un contexto no está soportada para tablas de referencias cruzadas. Se ha eliminado de esta vista de tabla de referencias cruzadas.  Vuelva a definir la regla en una o más categorías en el contexto de %{columnName}.',
	'dwErrorLoadingVisualizationNotFound': 'No podemos cargar el objeto porque le falta una definición de visualización.',
	'dwErrorLoadingVisualizationListNotFound': 'No podemos cargar la visualización.',
	'dwErrorRunningQuery': 'No se han podido recuperar los datos del conjunto de datos %{datasetName}.',
	'dwErrorGeoData': 'Han surgido problemas al mostrar los datos geográficos en un mapa. Elija otro tipo de visualización.',
	'dwPromptSignonCancelWarning': 'Los datos para esta visualización no están disponibles. Proporcione los credenciales correctos.',
	'dwErrorMissingDataset': 'No podemos cargar la visualización porque el conjunto de datos asociado "%{datasetName}" no está disponible.',
	'dwErrorRenderingVisualization': 'No podemos cargar esta visualización.',
	'dwErrorVisualizationTooSmall': 'La visualización es demasiado pequeña para mostrar los datos que contiene. Aumente el tamaño de la visualización o limite los datos que contiene.',
	'errorSourceNotFound': 'No podemos cargar la visualización porque el origen asociado "%{sourceName}" no está disponible.',
	'errorActionNotSupported': 'Esta acción no está soportada para el origen de datos "%{sourceName}".',
	'errorMeasureNotSupportedOnMultiEdges': 'La visualización tiene medidas en varios bordes, lo cual ya no está soportado. Coloque las medidas en un único borde.',
	'errorExceedAllowableValue': 'El número estimado de celdas supera el valor permitido de 100000. Aplique un filtro a los conjuntos proyectados para reducir el número de celdas.',
	'propScaleLabel': 'Cantidad de iconos',
	'propScaleDescription': 'Seleccione la cantidad de iconos',
	'propScaleFew': 'Baja',
	'propScaleDefault': 'Valor predeterminado',
	'propScaleMany': 'Alta',
	'lastRefresh': 'Última renovación: Hace %{timeInterval}',
	'widgetTimer': 'Temporizador del widget',
	'datasetItemsUnavailable': 'Algunos elementos del conjunto de datos utilizados en esta visualización no están disponibles.',
	'datasetItemUnavailable': 'Este elemento del conjunto de datos no está disponible.',
	'retry': 'Reintentar',
	'widgetConditionalFormatLabel': 'Conmutar controles de formato condicional',
	'widgetConditionalFormatTitle': 'Editar color de formato condicional',
	'crosstabName': 'Tabla de referencias cruzadas',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'N/D',
	'summaryLabel': '%{label} con el valor %{value}',
	'infographicLabel': '%{label} con el valor %{value}',
	'warning': 'Aviso',
	'swapRowsAndColumns': 'Intercambiar filas y columnas',
	'hideSummariesLabel': 'Ocultar resúmenes',
	'showSummariesLabel': 'Mostrar resúmenes',
	'hideRowColumn': 'Ocultar',
	'showAllRowColumn': 'Mostrar todo',
	'dataAssetPropertiesLabel': 'Propiedades de visualización',
	'evAdd': 'Añadir una columna',
	'evCollapse': 'Contraer',
	'evColumns': 'Columnas',
	'evLocalFilters': 'Filtros locales',
	'evExpand': 'Expandir',
	'evFilterTooltip': 'Filtro',
	'missingColumn': 'Falta: %{columnLabel}',
	'missingFiltering': 'Faltan filtros en columnas:',
	'missingDataItem': 'No se encuentra el elemento de datos "%%{dataItemId}" de referencia en el widget.',
	'heatByLabel': 'Uso crítico por',
	'toolbarChangeVisualization': 'Cambiar visualización',
	'modellingRelatedTablesNoneFound': 'No se han encontrado tablas relacionadas',
	'tablesNotJoined': 'Las relaciones entre las tablas no están definidas.',
	'fixTableJoin_edit': 'Ver relaciones',
	'processing': 'Procesando...',
	'errorCellWarning': 'No se han podido calcular algunos valores de resumen.',
	'aggregateTypeToggler': 'Mostrar tipo de agregación',
	'maxColumnsExceeded': 'Se ha superado el número de columnas. %{columns} descartadas.',
	'unboundColumns': 'No se pueden utilizar las columnas siguientes: %{columns}.',
	'unboundColumn': 'No se puede utilizar la columna siguiente: %{columns}.',
	'recommendRequestFailed': 'Ha fallado la solicitud de recomendación. Póngase en contacto con el administrador.',
	'visualizationDoesNotSupportOLAP': 'No se puede crear esta visualización basada en un origen de datos OLAP. Utilice otro origen de datos soportado.',
	'showDataBehindVizLabel': 'Mostrar datos',
	'showDataBehindVizNotSupportedLabel': 'No está soportado mostrar datos para este tipo de visualización.',
	'exploreData': 'Explorar...',
	'newExplore': 'Nueva exploración',
	'thumbnails_error_fetching': 'Error al capturar miniaturas',
	'loadedThumbnailImage': 'Se ha cargado la imagen en miniatura del tipo de visualización %{visType}',
	'autobinAxisLabel': 'grupos',
	'recommended_visualizations': 'Visualizaciones recomendadas',
	'all_visualizations': 'Todas las visualizaciones',
	'edit': 'Editar',
	'selectTargetDialogTitle': 'Seleccionar un destino de acceso a detalles',
	'noTargetInCM': 'No se puede encontrar el destino de acceso a detalles',
	'errorDrillDefinition': 'Se ha producido un error al añadir o editar la definición de obtención de detalles.',
	'errorDrillToTarget': 'Se ha producido un error al obtener detalles para "%{targetName}"',
	'drillThroughMappingViewLabel': 'Asignar columnas del panel de control a las solicitudes del informe de destino',
	'drillthroughScopeRadioLabel': 'Aplicar esta definición a:',
	'drillthroughScopeRadioOptionVisualization': 'Solo esta visualización',
	'drillthroughScopeRadioOptionConnection': 'Visualizaciones de la misma conexión que utilizan el mismo origen de datos',
	'drillthroughScopeRadioOptionDashboard': 'Cualquier visualización de %{perspective} que utiliza el mismo origen de datos',
	'drillThroughParametersColumnTitle': 'Solicitudes "%{targetName}":',
	'drillThroughMetadataColumnTitle': 'Columnas de datos "%{boardName}":',
	'drillThroughDefinitionNoParameter': 'El destino de acceso a detalles no tiene solicitudes.',
	'drillThroughDefinitionErrorQueryingReport': 'Corrija el problema con el informe de destino e intente de nuevo crear la definición de obtención de detalles.',
	'drillThroughDefinitionErrorDlgTitle': 'Se ha producido una anomalía',
	'dlg_back': 'Retroceder',
	'dlg_close': 'Cerrar',
	'dlg_ok': 'Aceptar',
	'dlg_cancel': 'Cancelar',
	'dlg_apply': 'Aplicar',
	'dlg_create': 'Crear',
	'dlg_done': 'Listo',
	'drillthrough_unsaveMsg': '¿Desea continuar sin guardar "%{name}"?',
	'drillthrough_jumpTo': 'Definición de acceso a detalles: %{name}',
	'drillthrough_jumpToLabel': 'Acceso a detalles',
	'drillthrough_manage': 'Gestionar...',
	'drillthrough_addNewTarget': 'Añadir una nueva definición de acceso a detalles',
	'drillthrough_manageJumpPaths': 'Gestionar definiciones de acceso a detalles',
	'drillthrough_manageJumpPaths_edit': 'Editar "%{name}"',
	'drillthrough_manageJumpPaths_delete': 'Suprimir "%{name}"',
	'drillthrough_manageAddAnotherTarget': 'Añadir otra definición de acceso a detalles',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Confirmar supresión',
	'drillthrough_manageConfirmeDeleteDrillTarget': '¿Seguro que desea suprimir el acceso a detalles "%{name}"?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Nombre de acceso a detalles duplicado',
	'drillthrough_definitionMessage': 'El acceso a detalles "%{name}" ya existe. Proporcione un nombre diferente',
	'drillthrough_jumpToTarget_notFound': 'No se ha encontrado el destino para el acceso a detalles "%{name}"',
	'drillThroughDefinitionNoParameterSubTitle': 'No se pasará ningún contexto al informe de destino.',
	'drillthrough_titleLabel': 'Nombre',
	'drillthrough_create_dialogTitle': 'Crear definición de acceso a detalles',
	'drillthrough_edit_dialogTitle': 'Editar definición de acceso a detalles',
	'drillthrough_subTitle': 'El contexto de la visualización en el origen se utiliza para filtrar el destino %{perspective}.',
	'drillthrough_selectColumn': 'Seleccionar una columna',
	'noPrompt': 'Sin solicitudes',
	'promptDialog': 'Diálogo de solicitud %{promptType}',
	'formatAutoDescription': 'Automático especifica el formato heredado desde el origen de datos o la visualización.',
	'formatDefaultDescription': 'Predeterminado especificado el formato heredado desde el sistema',
	'createCustomGroupAction': 'Crear grupo de datos',
	'removeCustomGroupAction': 'Eliminar grupo de datos',
	'editCustomGroupAction': 'Editar grupo de datos',
	'renameCustomGroupAction': 'Renombrar grupo de datos',
	'createCustomGroupErrorToast': 'No se ha podido crear su grupo de datos.',
	'removeCustomGroupErrorToast': 'No se ha podido eliminar su grupo de datos.',
	'editCustomGroupErrorToast': 'No se ha podido editar su grupo de datos.',
	'renameCustomGroupErrorToast': 'No se ha podido renombrar su grupo de datos.',
	'customGroupLabel': 'Crear grupo de datos',
	'ungroupCustomGroupLabel': 'Desagrupar',
	'renameCustomGroupLabel': 'Cambiar nombre',
	'createCustomGroupLabel': 'Crear',
	'customGroupingLabel': '%{columnLabel} (Grupo)',
	'createCustomBinningErrorToast': 'No se ha podido crear el grupo automático.',
	'removeCustomBinningErrorToast': 'El grupo automático no se ha podido eliminar.',
	'createCustomSort': 'Crear orden personalizado',
	'unavaiableData': 'Ningún dato',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': 'Seleccione los elementos disponibles y, a continuación cambie el orden para crear un orden personalizado.',
	'availableItems': 'Elementos disponibles',
	'selectAll': 'Seleccionar todo',
	'customSortOrder': 'Orden de clasificación personalizado',
	'selectAvailableItemsDesc': 'Seleccione los elementos disponibles y, a continuación cambie el orden de los mismos aquí.',
	'moveToTop': 'Mover al principio',
	'clear': 'Borrar',
	'sortRemainingItemsBy': 'Ordenar elementos restantes por',
	'removeAll': 'Eliminar todo',
	'resetTooltip': 'Se eliminarán todos los elementos de la lista %{customSortOrder}. Y el desplegable %{sortRemainingItemsBy} volverá al valor predeterminado.',
	'manyItemsWarning': 'Si se seleccionan muchos elementos el rendimiento del panel de control puede resultar afectado.',
	'manyItemsSelected': 'Se han seleccionado más de %{maxItems} elementos, esto puede afectar el rendimiento del panel de control.',
	'somethingWentWrong': '¡Ups! Algo no está bien del todo.',
	'tryAgain': 'Vuelva a intentarlo',
	'customSortLabel': 'Orden personalizado',
	'applyError': 'No se puede aplicar %{action}.',
	'searchReturnedNoResults': 'Lo sentimos, su búsqueda no ha devuelto ningún resultado.',
	'extVisSystem': 'Sistema',
	'extVisCustom': 'Personalizado',
	'customVisTestVisualization': 'Prueba de visualización',
	'extVisCustomVisPreview': 'vista previa',
	'extVisCustomPreviewWidgets': 'Widgets de desarrollador',
	'extVisCustomVVisualization': 'Visualización',
	'extVisCustomVisuals': 'Visualizaciones personalizadas',
	'noPermissionToManage': 'No tiene permiso para gestionar visualizaciones personalizadas.',
	'extVisCustomUpdate': 'Actualizar',
	'extVisCustomDelete': 'Suprimir',
	'extVisNoCustomVisuals': 'No hay visualizaciones personalizadas',
	'extVisNoCustomVisualsMsg': 'Actualmente no hay visualizaciones personalizadas en su organización.',
	'extVisAddCustomVisual': 'Añadir una visualización personalizada',
	'extVisNoCustomVisualsAdminMsg': 'Actualmente no hay visualizaciones personalizadas. Añada una para empezar',
	'extVisNoSDKConnection': 'No se ha creado ninguna conexión con su archivo local',
	'extVisNoSDKPreviewMsg': 'Para obtener una vista previa de sus visualizaciones, debe establecer una conexión.',
	'extVisMore': 'Más',
	'extVisDeleteDialogTitle': 'Suprimir visualización personalizada',
	'extVisDeleteDialogBody': '¿Está seguro de que desea suprimir visualización personalizada? Es posible que otros paneles de control e informes la estén utilizando.',
	'extVisDeleteConfirmation': 'Se ha suprimido su visualización personalizada.',
	'extVisDeleteError': 'No se ha podido suprimir su visualización personalizada. %{msg}',
	'extVisCloseToast': 'Cerrar ahora',
	'extVisAdd': 'Su visualización personalizada se ha añadido correctamente.',
	'extVisAddError': 'No se ha podido añadir su visualización personalizada. %{msg}',
	'extVisUpdate': 'Su visualización personalizada se ha actualizado correctamente.',
	'extVisUpdateError': 'No se ha podido actualizar su visualización personalizada. %{msg}',
	'extVisAddProgress': 'Importando %{name}',
	'extVisUpdateProgress': 'Actualizando %{name}',
	'extPermissionTitle': 'Acceso restringido o visualización personalizada suprimida',
	'extPermissionBody': 'No se puede ver esta visualización personalizada porque se ha suprimido o es de acceso restringido.',
	'customVizSaveWarning': 'No se han podido guardar sus visualizaciones personalizadas. No se han importado.',
	'schematicTestCaption': 'Probar Schematic',
	'schematicServiceRequestError': 'Error de servicio Schematic',
	'extVisPreviewMessage': 'Esta es una vista previa. Todavía no se ha añadido la visualización al producto.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'No definido',
	'kpiDefaultTargetLabel': 'Diana',
	'kpiNonNumericTarget': 'El valor de destino debe ser un número.',
	'kpiManualTargetSlotFilled': 'Valor aplicado al campo',
	'kpiAutoValueSize': 'Automático',
	'kpiUnableDrawSparklineLabel': 'No se ha podido trazar la Sparkline',
	'kpiUnableDrawSparklineInfo': 'Una sparkline requiere un mínimo de dos puntos en el tiempo. Cambie los datos o ajuste los filtros para ver la sparkline.',
	'conditionalFormattingTextColor': 'Color del texto',
	'suppression': 'Supresión',
	'suppressNone': 'Ninguno',
	'suppressRowsAndColumns': 'Filas y columnas',
	'suppressRows': 'Filas',
	'suppressColumns': 'Columnas',
	'enableSuppression': 'Habilitar supresión',
	'disableSuppression': 'Inhabilitar supresión',
	'loadVisDefinitionError': 'No se puede cargar la definición de la visualización %{id}',
	'emptyVisualization': 'Visualización vacía',
	'expandCollapse': 'Expandir y contraer',
	'expandBtnLabel': 'Expandir',
	'collapseBtnLabel': 'Contraer',
	'prop_sizeInputNonNumericValue': 'El valor debe ser un número.',
	'prop_sizeValueShouldBeHigher': 'El valor debe ser mayor que %{value}.',
	'fontPropLabel': 'Familia de fuentes',
	'fontSizePropLabel': 'Tamaño de fuente',
	'sectionItemAxisTitle': 'Título de eje del elemento',
	'sectionItemAxisLabel': 'Etiqueta de eje de elemento',
	'sectionValueAxisTitle': 'Título de eje del valor',
	'sectionValueAxisLabel': 'Etiqueta de eje de valor',
	'sectionRepeatColumnTitle': 'Repetir título de columna',
	'sectionRepeatRowTitle': 'Repetir título de fila',
	'styletext-widget.legend': 'Leyenda',
	'styletext-itemAxis.ticks.labels': 'Etiquetas de eje',
	'styletext-valueAxis.title': 'Títulos de eje',
	'styletext-itemAxis.title': 'Títulos de eje',
	'styletext-labels': 'Etiquetas de datos',
	'styletext-valueAxis.line.title': 'Títulos de línea',
	'styletext-cellValue': 'Valores',
	'styletext-values': 'Valores',
	'styletext-rowHeading': 'Cabeceras de filas',
	'styletext-columnHeading': 'Cabeceras de columna',
	'regularFontStyle':'Regular',
	'fontFamily': 'familia',
	'fontSize': 'tamaño',
	'visExportFileName': 'Visualización',
	'ds-missingDataSet': 'No se ha podido encontrar el conjunto de datos. Asegúrese de que el conjunto de datos se ha creado correctamente.',
	'ds-missingDashboardId': 'Guarde panel de control antes de crear el conjunto de datos.',
	'ds-unsupportedDataSourceType': 'No se da soporte al conjunto de datos %{type}.',
	'dataCache': 'Memoria caché de datos',
	'dataCache_on': 'Activado',
	'dataCache_off': 'Sin caché',
	'dataCache_auto': 'Automático',
	'queryOptimization': 'Optimización de consultas',
	'propshowDataGridInConsumeMode': 'Mostrar cuadrícula de datos en vista previa',
	'dtMatchMetadata': 'Utilice metadatos coincidentes para filtrar el panel de control de destino.',
	'dtMatchMetadata_info': 'Si el panel de control de destino se basa en un origen de datos distinto, aplique filtros cuando los identificadores de metadatos coincidan. Esto puede afectar al rendimiento.',
	'dtOverrideExistingFilters': 'Modifique solo los filtros globales que ya están presentes en el panel de control de destino.\nSe ignoran otros filtros en la visualización de origen.',
	'OnLoadFilterModifierDatasourceMismatch': 'Los filtros no se aplicarán al destino debido a que los paneles de control están utilizando orígenes diferentes.',
	'OnLoadFilterModifierColumnMismatch': 'Uno o varios filtros no se han aplicado porque no se han encontrado las columnas coincidentes.',
	'showValuesOn': 'Mostrar valores en',
	'showValuesAsRowLabel': 'Filas (cuando mejor)',
	'showValuesAsColumnLabel': 'Columnas (cuando mejor)',
	'dropdownMultiSelectClearAll': 'Borrar todas las selecciones',
	'dropdownSingleSelectClearAll': 'Borrar la selección',
	'dropdownOpenMenu': 'Abrir menú',
	'dropdownCloseMenu': 'Cerrar menú',
	'cascadingFiltersSection': 'Valores de filtro en cascada',
	'cascadeStrategy': 'Representar en cascada estrategia de conjunto',
	'cascadeStrategy_FirstToLast': 'De primero a último',
	'cascadeStrategy_MultiDirectional': 'Multidireccional',
	'cascade_globalToTab': 'Representar en cascada Todos los filtros de pestañas',
	'cascade_tabToLocal': 'Representar en cascada Esta pestaña filtra a local',
	'showAllData': 'Mostrar todos los valores',
	'showAllFilterValue': '(%{value})',
	'valuesCascaded': 'Valores filtrados por todas las pestañas',
	'AnalyticsMsgDefault': 'El widget seleccionado no utiliza previsiones ni conocimientos analíticos',
	'AnalyticsDescriptionDefault': 'Seleccione una visualización con soporte de análisis para ver y gestionar los valores de análisis.',
	'AnalyticsMsgNoContent': 'No se ha seleccionado ninguna visualización',
	'AnalyticsMsgMultiSelected': 'Varios widgets seleccionados',
	'AnalyticsDescriptionMultiSelected': 'Seleccione una visualización para ver y gestionar el valor de análisis para ella.',
	'ChartInsightPinnedSectionDescription':'Su información narrativa favorita también se comparte cuando comparte el panel de instrumentos. La información puede verse afectada por los cambios de los datos y no se muestra si no se aplica a los datos actuales.',
	'ChartInsightNonPinnedSectionDescription':'La información sugerida es generada por el sistema para su visualización. Esta información puede cambiar si hay un cambio en los datos.',
	'ChartInsightPinnedSectionTitle':'Información favorita (%{count})',
	'ChartInsightNonPinnedSectionTitle':'Información sugerida (%{count})',
	'ChartInsightPinnedEmpty':'Pulse el icono de estrella para ver información sugerida para añadirla como favorito.',
	'ChartInsightAllInsightsPinned': 'No hay nueva información disponible o se ha añadido toda la información sugerida a los favoritos.',
	'ChartInsightNoRecommendedInsights': 'No hay información para esta visualización.',
	'ChartInsightLoadingMessage':'Búsqueda de información narrativa para sus datos',
	'ChartInsightConsumePinnedInsightsDesc': 'El autor del panel de control ha añadido esta información como favorito.',
	'MoveUp':'Subir información',
	'MoveDown':'Bajar información',
	'Star':'Añadir información a favoritos',
	'Unstar':'Eliminar información de favoritos',
	'DisabledUnstar': 'Información añadida como favorito',
	'PdfPrintSectionLabel': 'Valores de impresión en PDF',
	'PdfPrintOptionsLabel': 'Opciones de impresión',
	'PdfPrintInViewLabel': 'En vista',
	'PdfPrintExtendedContentLabel': 'Contenido ampliado',
	'PdfPrintNewPageLabel': 'Nueva página'
});
